import FeatureInPageBanner from "@/core/infrastructure/repository/feature/FeatureInPageBanner"
import hasData from "@/core/domain/specification/hasData"

export default class FeatureInPageBannerService {
    protected featureInPageBanner: FeatureInPageBanner

    constructor() {
        this.featureInPageBanner = new FeatureInPageBanner()
    }

    async process() {
        const { data, totalCount } = await this.featureInPageBanner.fetch()

        if (!hasData(totalCount)) {
            throw new TypeError("No data was provided")
        }

        return data
    }
}
